import LogRocket from 'logrocket'
import posthog from 'posthog-js'

/**
 * Call once at app startup (after PostHogProvider mounts and user is identified)
 * to conditionally start session recording based on the LaunchDarkly flag.
 */
export function initAnalytics(sessionReplayEnabled?: boolean): void {
  if (process.env.POSTHOG_PROJECT_TOKEN && sessionReplayEnabled) {
    posthog.startSessionRecording()
  }
}

function isLogRocketEnabled(): boolean {
  return !!process.env.LOGROCKET_APP_ID
}

function isPostHogEnabled(): boolean {
  return !!process.env.POSTHOG_PROJECT_TOKEN
}

export function track(eventName: string, properties?: Record<string, any>): void {
  if (isLogRocketEnabled()) {
    LogRocket.track(eventName)
  }
  if (isPostHogEnabled()) {
    posthog.capture(eventName, properties)
  }
}

export function info(message: string | object, data?: any): void {
  if (isLogRocketEnabled()) {
    LogRocket.info(message as any, data)
  }
  if (isPostHogEnabled()) {
    const eventName = typeof message === 'string' ? message : 'info'
    const eventData = typeof message === 'object' ? message : data != null ? { data } : undefined
    posthog.capture(`info:${eventName}`, eventData)
  }
}

export function error(message: string, data?: any): void {
  if (isLogRocketEnabled()) {
    LogRocket.error(message, data)
  }
  if (isPostHogEnabled()) {
    posthog.capture(`error:${message}`, { data, level: 'error' })
  }
}

export function captureMessage(message: string): void {
  if (isLogRocketEnabled()) {
    LogRocket.captureMessage(message)
  }
  if (isPostHogEnabled()) {
    posthog.capture(message)
  }
}
